import cancelIcon from '@jetbrains/icons/cancel'
import exceptionEmptyIcon from '@jetbrains/icons/exception-empty'
import hourglassIcon from '@jetbrains/icons/hourglass'
import okIcon from '@jetbrains/icons/ok'
import pinFilledIcon from '@jetbrains/icons/pin-filled'
import spinnerStaticIcon from '@jetbrains/icons/spinner-static'
import starFilledIcon from '@jetbrains/icons/star-filled'
import warningEmptyIcon from '@jetbrains/icons/warning-empty'

export enum BuildState {
  ALL = 'all',
  QUEUED = 'queued',
  RUNNING = 'running',
  SUCCESSFUL = 'successful',
  FAILED = 'failed',
  FAILED_TO_START = 'failedToStart',
  CANCELED = 'canceled',
  PINNED = 'pinned',
  STARRED = 'starred',
}

export type BuildStateCount = {
  value: number
  hasMore: boolean
}

export const StateOptions = {
  [BuildState.ALL]: {
    title: 'All',
    icon: null,
    svgIcon: null,
  },
  [BuildState.QUEUED]: {
    title: 'Queued',
    icon: 'queued',
    svgIcon: hourglassIcon,
  },
  [BuildState.RUNNING]: {
    title: 'Running',
    icon: 'running_static',
    svgIcon: spinnerStaticIcon,
  },
  [BuildState.SUCCESSFUL]: {
    title: 'Successful',
    icon: 'finished_green',
    svgIcon: okIcon,
  },
  [BuildState.FAILED]: {
    title: 'Failed',
    icon: 'finished_red',
    svgIcon: exceptionEmptyIcon,
  },
  [BuildState.FAILED_TO_START]: {
    title: 'Failed to start',
    icon: 'failedToStart',
    svgIcon: warningEmptyIcon,
  },
  [BuildState.CANCELED]: {
    title: 'Canceled',
    icon: 'canceled',
    svgIcon: cancelIcon,
  },
  [BuildState.PINNED]: {
    title: 'Pinned',
    icon: 'pin',
    svgIcon: pinFilledIcon,
  },
  [BuildState.STARRED]: {
    title: 'My favorites',
    icon: 'star',
    svgIcon: starFilledIcon,
  },
} as const
